<div askModalHeader class="modal-title" data-testid="modal-title">
  {{ "PHONE_STATUS_MODAL.TITLE" | translate }}
</div>

<div askModalBody class="modal-body" data-testid="modal-body">
  {{ "PHONE_STATUS_MODAL.MESSAGE" | translate }}
</div>

<div askModalFooter class="modal-footer">
  <ask-button-v2
    data-testid="cancel-action"
    appearance="brand"
    (click)="onCancelClick()"
  >
    {{ "PHONE_STATUS_MODAL.CANCEL_BUTTON" | translate }}
  </ask-button-v2>
  <ask-button-v2
    data-testid="confirm-action"
    appearance="transparent"
    (click)="onConfirmClick()"
  >
    {{ "PHONE_STATUS_MODAL.CONFIRM_BUTTON" | translate }}
  </ask-button-v2>
</div>
